/* eslint-disable */
import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import { setI18nLanguage, loadLocaleMessages, SUPPORT_LOCALES } from "@/i18n";
import Home from "../components/home/Home.vue";
import login from "../components/login/login.vue";
import PatientLoginScreen from "../components/PatientLoginScreen/PatientLoginScreen.vue";
import PatientDashboard from "../components/PatientDashboard/PatientDashboard.vue";
import Signup from "../components/signUp/signUp.vue";
import visitsummary from "../components/visit_summary/visit_summary.vue";
import nursediary from "../components/NurseDiary/NurseDiary.vue";
import Form from "../components/form/form.vue";
import Settings from "../components/settings/settings.vue";
import labTest from "../components/labTest/labTest.vue";
import editLabtest from "../components/editLabtest/editLabtest.vue";
import listform from "../components/form_list/form_list.vue";
import meddralistforms from "../components/meddraFormsList/meddraformslist.vue";
import labMaster from "../components/labMaster/labMaster.vue";
import formssummery from "../components/formsummery/formsummery.vue";
import formSummary from "../components/formSummary/formSummary.vue";
import showform from "../components/showform/showform.vue";
import showformwithdata from "../components/showformwithdata/showformwithdata.vue";
import mapform from "../components/mapForm/mapForm.vue";
import userlist from "../components/user_listing/user_list.vue";
import devicecontrollers from "../components/device_controllers/device_controllers.vue";
import sitelist from "../components/site_listing/site_list.vue";
import templatelist from "../components/template_listing/template_list.vue";
import templatelisting from "../components/template_listing_all/template_list_all.vue";
import queryList from "../components/query_listing/query_List.vue";
import ReceivedQueryForAlerts from "../components/ReceivedQueryForAlerts/ReceivedQueryForAlerts.vue";
import sentQueryList from "../components/sent_query_listing/sent_query_listing.vue";
import sentQueryListForAlert from "../components/sentQueryListForAlert/sentQueryListForAlert.vue";
import allQueryList from "../components/all_query_listing/all_query_listing.vue";
import allQueriesForAlert from "../components/allQuriesForAlert/allQuriesForAlert.vue";
import general_querylist from "../components/general_querylist/general_querylist.vue";
import raiseQuery from "../components/raise_query/raise_query.vue";
import generalQuery from "../components/general_query/general_query.vue";
import viewTemplate from "../components/view_template/view_template.vue";
import viewFormTemplate from "../components/view_template_all/view_template_all.vue";
import managesite from "../components/manage_site/manage_site.vue";
import managecountry from "../components/StudyCountry/ManageCountry.vue";
import ArmManagement  from "../components/ARM/ArmManagement.vue";
import documentapprovallist from "../components/DocumentApproval/DocumentApprovalList.vue";
import patientlist from "../components/patient_listing/patient_list.vue";
import patientLoginList from "../components/patient_login_list/patient_login_list.vue";
import patientLoginPassword from "../components/Patient_password/patient_password.vue";
import managePatient from "../components/manage_patient/manage_patient.vue";
import createuser from "../components/create_user/createUser.vue";
import visitlist from "../components/visit_list/visitList.vue";
import visitforms from "../components/visitforms/visitforms.vue";
import visitSheduleList from "../components/visit_shedule/visit_shedule.vue";
import addvisit from "../components/Add_Visit/addVisit.vue";
import displayform from "../components/UI_form/formlisting.vue";
import study from "../components/study/study.vue";
import editLabs from "../components/editLab/editLabs.vue";
import assignTest from "../components/assignTest/assignTest.vue";
import studylist from "../components/study_listing/study_list.vue";
import querymapping from "../components/query/queryMapping.vue";
import manageRole from "../components/manage_role/manage_role.vue";
import roleList from "../components/role_listing/role_listing.vue";
import userpassword from "../components/user_password/userPassword.vue";
import ResetPassword from "../components/ForgotPassword/ResetPassword.vue";
import CheckEmail from "../components/ForgotPassword/CheckEmail.vue";
import visitList from "../components/visitList/visitList.vue";
import userPrivilege from "../components/user_study_privilege/userprivilege.vue";
import roleScreen from "../components/RoleScreen/RoleScreen.vue";
import studytemplate from "../components/study_template/studyTemplate.vue";
import screen from "../components/screen/screen.vue";
import documentsummary from "../components/Document_Summary/documentSummary.vue";
import siteprivilege from "../components/siteprivilege/siteprivilege.vue";
import sitesummary from "../components/site_summary/site_dashboard.vue";
import studysummary from "../components/study_summary/study_summary.vue";
import visittemplate from "../components/visit_template/visit_template.vue";
import googlefit1 from "../components/googleFit/googlefit.vue";
import store from "../store/index";
import PatientScheduleView from "../components/PatientSchedule/PatientScheduleView.vue";
import submitForm from "../components/Submit_Form/submitForm.vue";
import subject_schedule from "../components/subject_schedule/subject_schedule.vue";
import StudyBasedUserList from "../components/StudyBasedUser/StudyBasedUserList.vue";
import noprivilege from "../components/noprivilegepage/noprivilege.vue";
import report from "../components/report_page/report.vue";
import patientreport from "../components/patient_report/patient_report.vue";
import reportdashboard from "../components/reports/report_dashboard.vue";
import dmssummaryreport from "../components/reports/dms_summary_report.vue";
import siteReport from "../components/report_site/site_report.vue";
import visitSummaryReport from "../components/visitSummaryReport/visitSummary_report.vue";
import editForm from "../components/editfrom/editform.vue";
import device from "../components/iot_devices/device.vue";
import patientdocument from "../components/PatientDocument/PatientDocument.vue";
import iotpatients from "../components/iot_patients/IOTPatients.vue";
import unscheduledvisits from "../components/unscheduledvisitlist/unscheduledvisits.vue";
import folder from "../components/folder/folder.vue";
import dms from "../components/generaldocument/dms.vue";
import document_patient from "../components/document_patient/document_patient.vue";
import nursesummary from "../components/nurse_summary/nurse_dashboard.vue";
import digitalform from "../components/Digital_form/digital_form.vue";
import digitalformview from "../components/View_digital_form/view_digital_form.vue"
import folderstudy from "../components/folderstudy/folderstudy.vue";
import documentview from "../components/Document_view/documentview.vue";
import viewdocument from "../components/View_Document/view_document.vue";
import reviewFormList from "../components/ReviewFormList/ReviewFormlist.vue";
import fieldprivileges from "../components/field_privileges/field_privileges.vue"
import archive from "../components/Archive/Archive.vue";
import transferSubject from "../components/transferSubject/transferSubject.vue";
import formtransfer from "../components/formtransferpage/formtransfer.vue";
import googlefitscreen from "../components/googleFitScreen/googleFit.vue";
import formdesigner from "../components/DesignForm/form_design.vue";
import formdesignertool from "../components/DesignFormAll/form_design_all.vue";
import viewform from "../components/viewform/viewform.vue";
import viewformtemplate from "../components/viewformtemplate/viewformtemplate.vue";
import VideoCall from "../components/videocall/VideoCallPage.vue"
import templateview from "../components/view_template_form/view_template_form.vue"
import profileSettings from "../components/profileSettings/profileSettings.vue"
import ConfirmationScreen from "../components/Confirmation/confirmation.vue"
import formTemplate from "../components/formTemplate/formTemplate.vue"
import studyProfile from "../components/Study_Profile/Study_Profile.vue"
import createNewVersion from "../components/createNewVersion/createNewVersion.vue"
import dataExport from "../components/DataExport/DataExport.vue"
import dataStandard from "../components/DataStandards/DataStandards.vue"
import interimDataset from "../components/Stats_Interim_Analysis/interimDataset.vue"
import dynamicdashboard from "../components/dynamicdashboard/dynamicdashboard.vue"
import eConsent from "../components/eConsent/eConsent.vue"
import FormSuggestions from "../components/FormSuggestions/FormSuggestions.vue"
import mlCriteriaCapture from "../components/mlCriteriaCapture/mlCriteriaCapture.vue"
import test from "../components/test.vue"
import ailist from "../components/AI_List/ai_list.vue"
import filediffpage from "../components/Diffviewer/filediffpage.vue"
import survivalreport from "../components/SurvivalAnalysis/SurvivalAnalysis.vue"
import aereport from "../components/AdverseEventsReport/ae_report.vue"
import PatientScreeningReport from "../components/PatientScreeningReport/PatientScreeningReport.vue"
import PatientRetention from "../components/PatientRetention/PatientRetention.vue"
import RetentionDashboard from "../components/RetentionDashBoard/RetentionDashboard.vue"
import descriptiveStatistic from "../components/Statistic_descriptive/descriptiveStatistic.vue"
import deathsummaryreport from "@/components/DeathSummaryReport/deathsummaryreport.vue";
import AnalyticalDashboard from "@/components/Analytical_Dashboards/Analytical_Dashboards.vue";
import StudyMonitoring from "@/components/Study_Monitoring/Study_monitoring.vue";
import labsummeryreport from "@/components/LabSummeryReport/labsummeryreport.vue";
import medicalhistory from "@/components/MedicalHistoryReport/medicalhistory.vue";
import medicalhistorycrosstab from "@/components/MedicalHistoryCrossTabulation/Medicalhistorycrosstabulation.vue";
import labdescriptivestatus from "@/components/LabDescriptiveStats/Labdescriptivestats.vue";
import labresultreview from "@/components/LabresultReview/labresultreview.vue";
import vitalsignreport from "@/components/VitalsignReport/vitalsignreport.vue";
import vitalsigndescriptivestats from "@/components/VitalSignsDescriptiveStats/Vitalsignsdescriptivestats.vue";
import demographicReport from "@/components/DemographicSummaryReport/DemographicSummaryReport.vue"
import subjectstatusreport from "@/components/Subject_status_report/status_report.vue"
import advereventcrosstabulation from "@/components/adverseEventCrossTabulation/adverseEventCrossTab.vue"
import labResultTrend from "@/components/LabResultTrendsReport/LabResultTrend.vue"
import treatmentEmergentAE from "@/components/treatementEmergentAE/treatementEmergentAE.vue";
import ae_OverlayLabsReport from "@/components/AE_OverlayLabsReport/AE_OverlayLabsReport.vue";
import vitalsignsresultovertime from "@/components/vitalSignsResultOvertime/vitalSignsResultOvertime.vue";
import aeincidencetable from "@/components/AEIncidenceTable/AEIncidenceTable.vue";
import priorconcomitantsummary from "@/components/priorConcomitantSummary/priorConcomitantSummary.vue";
import exposurereport from "@/components/ExposureReport/exposurereport.vue"
import exposureandadverseevents from "@/components/ExposureAndAdverseEvents/exposureandadverseevents.vue"
import comparativelabresult from "@/components/comparativeLabResult/comparativeLabResult.vue"
import patientenrolment from "@/components/PatientEnrollment/PatientEnrollment.vue"
import trainingMaterials from "@/components/TrainingMaterials/trainingMaterials.vue";
import consentFormList from "@/components/consentform_list/consentFormList.vue";
import subjectlogin from "../components/subjectlogin/subjectlogin.vue"
import acknowledgement from "../components/acknowledgement/acknowledgement.vue";
import patientUpdate from "../components/patientUpdate/patientUpdate.vue";
import sitequerymonitoring from "../components/Site_Query_monitoring/Site_query_monitoring.vue";
import ae_sae_monitoring from "../components/AE_SAE_Monitoring/ae_sae_monitoring.vue";
import siteactivitymonitoring from '../components/Site_Activity_monitoring/Site_Activity_monitoring.vue';
import landingPage from "@/components/LandingPage/landingPage.vue";
import siteperformance from '../components/site_performance/siteperformance.vue'
import costmonitoring from '../components/CostMonitoringReport/CostMonitoringReport.vue'
import uploadstudyprotocol from "../components/uploadStudyProtocol/uploadStudyProtocol.vue";
import StudyProtocolMng from "../components/DataScrape/StudyProtocolMangement/StudyProtocolMng.vue";
import StudyManagment from "../components/DataScrape/StudyManagment/StudyManagment.vue";
import FormManagement from "../components/DataScrape/Formmanagement/FormManagement.vue";
import VisitManagement from "../components/DataScrape/VisitManagement/VisitManagement.vue";
import SiteManagement from "../components/DataScrape/SiteManagement/SiteManagement.vue";
import SubjectManagement from "../components/DataScrape/SubjectManagement/SubjectManagement.vue";
import ScheduleManagement from "../components/DataScrape/ScheduleManagement/ScheduleManagement.vue";
import aecostmonitoring from '../components/AE_Cost_Monitoring/Ae_Cost_monitoring.vue';
import tocgenerate from '../components/ToCgenerate/tocgenerate.vue';
import stats from "../components/Stats/Stats.vue";
import Macro_Management from "../components/Macro_Management/Macro_Management.vue";
import sdtm from "../components/SDTM/sdtm_conversion.vue"
import graphvisual from "../components/graph_visual/graphvisual.vue"
import viewgraph from "../components/graph_view/graphview.vue"
import soa from "../components/SoA/soa.vue"
import sapConnection from "../components/sapConnection/sapConnection.vue"
import crm from "../components/crm/crm.vue"
import inventoryTracking from "@/components/inventoryTracking/inventoryTracking.vue"
import fhirViewer from "@/components/fhirViewer/fhirViewer.vue";
import analysisTreeQC from "@/components/analysisTree/analysisTree.vue";
import FHIRpage from "@/components/FHIRpage/FHIRpage.vue";
import exportOutput from "@/components/exportOutput/exportOutput.vue"
import scheduleTask from "@/components/scheduleTask/scheduleTask.vue"
import ClinicalSafetyDashboard from "@/components/ClinicalSafetyDashboard/ClinicalSafetyDashboard.vue"
import RiskBasedMonitoring from "@/components/RiskBasedMonitoring/RiskBasedMonitoring.vue";
import etmf from "@/components/trialMasterFile/trialMasterFile.vue"
import StudystatusMaster from "@/components/StudyStatusMaster/StudyStatusMaster.vue"
import etmfdoc from "@/components/TmfDocApprovals/TmfDocApproval.vue"
import TmfDocReviewList from "@/components/TmfDocApprovals/TmfDocReviewList.vue"
import TmfDocQcList from "@/components/TmfDocApprovals/TmfDocQcList.vue"
import analysis_report from "@/components/analysis_report/analysis_report.vue";
import importstudy from "@/components/ImportStudy/ImportStudy.vue"
import statqc_report from "@/components/statqc_report/statqc_report.vue";
import statusentry_report from "@/components/StatusEntryReport/statusentry_report.vue";
import programvalidation_report from "@/components/ValidationReport/programvalidation_report.vue";
import folderDocLogin from "@/components/folderDocLogin/folderDocLogin.vue";
import traceability_report from "@/components/TraceabilityReport/traceability_report.vue";
import subjectdashboard from "@/components/subject_dashboard/subject_dashboard.vue";
import ePRO from "@/components/ePRO/epro.vue";
import alerts from "@/components/setalert/setalert.vue";
import Alerts from "@/components/Alerts/alerts.vue";
import Setalert from "@/components/setalert/setalert.vue";
import SetAlertModal from "@/components/setalert/SetAlertModal.vue";
import ViewAlertModal from "@/components/setalert/ViewAlertModal.vue";
import subjectdiaries from "@/components/subject_diaries/subject_diaries.vue";
import setfhiralert from "@/components/setfhiralert/setfhiralert.vue"
import alertreport from "@/components/Alert_reports/alert_report.vue";
import ractfileimport from "@/components/RactFileImport/RactFileImport.vue";
import eproSubjects from "@/components/eproSubjects/eproSubjects.vue";
import ractTool from "@/components/RactTool/RactTool.vue";
import etmfdashboard from "@/components/etmfdashboard/etmfdashboard.vue";
import etmfuserdashboard from "@/components/etmfuserdashboard/etmfuserdashboard.vue";
import importtoformlibrary from "@/components/ImportToFormLibrary/importtoformlibrary.vue";
// import stats from "../components/Stats/Stats.vue"
//import aiform from "../components/FormAi/";
//import FormSuggestions from "../components/FormSuggestions/FormSuggestions.vue";
//import aiform from "../components/FormAi/AiForm.vue";
import AlertSummary from "@/components/AlertSummary/AlertSummary.vue";
import formindex from "@/components/form_index/form_index.vue";
import activitygraph from "@/components/activity_graph/activity_graph.vue";
import organization_settings from "@/components/organization_settings/organization_settings.vue";
import rbqmdashboard from "@/components/rbqm_dashboard/rbqm_dashboard.vue";
import riskSummary from "@/components/RiskSummary/RiskSummary.vue";
import criticalDataInventory from "@/components/CriticalDataInventory/CriticalDataInventory.vue";
import riskRegister from "@/components/RiskRegister/RiskRegister.vue";
import datasignal from "@/components/dataSignal/dataSignal.vue";
import f4pViewer from "@/components/f4p/f4pViewer.vue";
import rbqmreport from "@/components/rbqm_report/rbqm_report.vue";
import signerslist from "@/components/Signers_list/signerslist.vue";
import signfrompopup from "@/components/signfrompopup/signfrompopup.vue"
import sdvSummary from "@/components/SDV_Summary/SDV_Summary.vue";
import StudyCountry from "@/components/StudyCountry/StudyCountry.vue";
import etmfreport from "@/components/etmfReport/etmfreport.vue";
import crfView from "@/components/crfView/crfView.vue";
import crfViewsingle from "@/components/crfViewsingle/crfViewsingle.vue";
import meddraViewer from "@/components/meddraViewer/meddraViewer.vue";
import studydiffviewer from "@/components/studydiffviewer/studydiffviewer.vue"
import ArmVisitTree from "@/components/ARM/ArmVisitTree.vue";
import InteligentDashboard from "@/components/rbqmInteligentDashboard/rbqmInteligentDashboard.vue";
import VisitActivityTree from "@/components/VisitActivityTree/VisitActivityTree.vue";
import visitInfo from "@/components/VisitInfo/VisitInfo.vue";
import AACT_Study_Comparison from "@/components/AACT_Study_Comparison/AACT_Study_Comparison.vue";
import ResearchFhirSubject from "@/components/ResearchFhirSubject/ResearchFhirSubject.vue";
import subject_tree from "@/components/subject_tree/subject_tree.vue";
import datadashboard from "@/components/datadashboard/datadashboard.vue";
import monitorDashboard from "@/components/monitorDashboard/monitorDashboard.vue";
import cradashboard from "@/components/cra_dashboard/cra_dashboard.vue";
import cralist from "@/components/CraManagement/CraList.vue";
import crascheduellist from "@/components/CraManagement/CraScheduleList.vue";
import schedulelist from "@/components/CraManagement/ScheduleList.vue";
import KPIs from "@/components/KPIs/KPIs.vue";
import CRA_Summary from "@/components/CRA_summary/CRA_summary.vue";
import RAC_Insight from "@/components/RAC_Insight/RAC_Insight.vue"
import DataSignalOverview from "@/components/DataSignalOverview/DataSignalOverview.vue";

function load(component: any) {
  // '@' is aliased to src/components
  return () => import(`@/views/${component}.vue`);
}
export function setupRouter(i18n: {
  mode: string;
  global: { locale: { value: any } };
}) {
  const locale =
    i18n.mode === "legacy" ? i18n.global.locale : i18n.global.locale.value;

  const routes: Array<RouteRecordRaw> = [
    {
      path: "/crfViewsingle/:tempId/:formId/:comments",
      name: "crfViewsingle",
      component:crfViewsingle,
      props: true,
      meta: { requiredAuth: true, roleprivilage: "Study Components Menu CRF View" },
    },
    {
      path: "/RAC_Insight",
      name: "RAC_Insight",
      component:RAC_Insight,
      props: true,
      meta: { requiredAuth: true},
    },
    {
      path: "/CTMS_Dashboard",
      name: "CTMS_Dashboard",
      component:CRA_Summary,
      props: true,
      meta: { requiredAuth: true},
    },
    {
      path: "/subject_tree/:subjectId",
      name: "subject_tree",
      component:subject_tree,
      props: true,
      meta: { requiredAuth: true},
    },
      {
      path: "/crfView/:crfid/:formId",
      name: "crfView",
      component:crfView,
      props: true,
      meta: { requiredAuth: true, roleprivilage: "Study Components Menu CRF View" },
    },
    {
      path: "/signfrompopup/:envelopeId/:recipientEmail/:signorder",
      name: "signfrompopup",
      component:signfrompopup,
      props: true,
      meta: { requiredAuth: true },
    },
    {
      path: "/baseline_comparison",
      name: "AACT_Study_Comparison",
      component: AACT_Study_Comparison,
      meta: { requiredAuth: true},
    },
    {
      path: "/datadashboard",
      name: "datadashboard",
      component: datadashboard,
      meta: { requiredAuth: true},
    },
    {
      path: "/monitorDashboard",
      name: "monitorDashboard",
      component: monitorDashboard,
      meta: { requiredAuth: true},
    },
    {
      path: "/cradashboard",
      name: "cradashboard",
      component: cradashboard,
      meta: { requiredAuth: true},
    },
    {
      path: "/cralist",
      name: "cralist",
      component: cralist,
      meta: { requiredAuth: true},
    },
    {
      path: "/crascheduellist",
      name: "crascheduellist",
      component: crascheduellist,
      meta: { requiredAuth: true},
    },
    {
      path: "/schedulelist",
      name: "schedulelist",
      component: schedulelist,
      meta: { requiredAuth: true},
    },
    {
      path: "/kpilist",
      name: "kpilist",
      component: KPIs,
      meta: { requiredAuth: true},
    },
    {
      path: "/InteligentDashboard",
      name: "InteligentDashboard",
      component: InteligentDashboard,
      meta: { requiredAuth: true},
    },
    {
      path: "/studydiffviewer",
      name: "studydiffviewer",
      component: studydiffviewer,
      meta: { requiredAuth: true},
    },
    {
      path: "/etmfreport",
      name: "etmfreport",
      component: etmfreport,
      meta: { requiredAuth: true},
    },
     {
      path: "/Scheduleofactivities",
      name: "Scheduleofactivities",
      component: ArmVisitTree,
      meta: { requiredAuth: true},
    },
    {
      path: "/signerslist",
      name: "signerslist",
      component: signerslist,
      meta: { requiredAuth: true},
    },
    {
      path: "/etmfdashboard",
      name: "etmfdashboard",
      component: etmfdashboard,
      meta: { requiredAuth: true},
    },
    {
      path: "/etmfuserdashboard",
      name: "etmfuserdashboard",
      component: etmfuserdashboard,
      meta: { requiredAuth: true},
    },
    {
      path: "/VisitActivityTree/:version",
      name: "VisitActivityTree",
      component: VisitActivityTree,
      props: true,
      meta: { requiredAuth: true},
    },
    {
      path: "/StudyCountry",
      name: "StudyCountry",
      component: StudyCountry,
      meta: { requiredAuth: true},
    },
     {
      path: "/ArmManagement",
      name: "ArmManagement",
      component: ArmManagement,
      meta: { requiredAuth: true},
    },
    {
      path: "/f4pViewer",
      name: "f4pViewer",
      component: f4pViewer,
      meta: { requiredAuth: true, role: "F4P Role"},
    },
    {
      path: "/rbqm_dashboard",
      name: "rbqmdashboard",
      component: rbqmdashboard,
      meta: { requiredAuth: true},
    },
    {
      path: "/rbqmreport",
      name: "rbqmreport",
      component: rbqmreport,
      meta: { requiredAuth: true},
    },
    {
      path: "/riskRegister",
      name: "riskRegister",
      component: riskRegister,
      meta: { requiredAuth: true},
    },
      {
      path: "/datasignal",
      name: "datasignal",
      component: datasignal,
      meta: { requiredAuth: true},
    },
    {
      path: "/organization_settings",
      name: "organization_settings",
      component: organization_settings,
      meta: { requiredAuth: true},
    },
    {
      path: "/activitygraph",
      name: "activitygraph",
      component: activitygraph,
      meta: { requiredAuth: true},
    },
    {
      path: "/formindex",
      name: "formindex",
      component: formindex,
      meta: { requiredAuth: true},
    },
     {
      path: "/eproSubjects",
      name: "eproSubjects",
      component: eproSubjects,
      meta: { requiredAuth: true},
    },
    {
      path: "/setfhiralert",
      name: "setfhiralert",
      component: setfhiralert,
      meta: { requiredAuth: true, roleprivilage: "Mainmenu setfhiralert"},
    },
    {
      path: "/doclogin",
      name: "folderDocLogin",
      component: folderDocLogin,
    },
    {
      path: "/alertreport",
      name: "alertreport",
      component:alertreport,
      props: true,
      meta: { requiredAuth: true, roleprivilage: "Mainmenu Alerts"},
    },
    {
      path: "/subjectdiaries",
      name: "subjectdiaries",
      component:subjectdiaries,
      props: true,
      meta: { requiredAuth: true, roleprivilage: "Mainmenu Subject Diaries"},
    },
    {
      path: "/subjectdashboard",
      name: "subjectdashboard",
      component:subjectdashboard,
      props: true,
      meta: { requiredAuth: true, roleprivilage: "Dashboard Subject Dashboard"  },
    },
    {
      path: "/importstudy",
      name: "importstudy",
      component:importstudy,
      props: true,
      meta: { requiredAuth: true , roleprivilage: "Mainmenu Import Study"},
    },
    {
      path: "/etmf",
      name: "etmf",
      component:etmf,
      props: true,
      meta: { requiredAuth: true, roleprivilage: "ETMF Menu ETMF" },
    },
        {
      path: "/StudystatusMaster",
      name: "StudystatusMaster",
      component:StudystatusMaster,
      props: true,
      meta: { requiredAuth: true, roleprivilage: "Study Administration Menu Unscheduled Visits" },
    },
     {
      path: "/etmfdoc",
      name: "etmfdoc",
      component:etmfdoc,
      props: true,
      meta: { requiredAuth: true, roleprivilage: "ETMF Menu Approvals" },
    },
    {
      path: "/TmfDocReviewList",
      name: "TmfDocReviewList",
      component:TmfDocReviewList,
      props: true,
      meta: { requiredAuth: true, roleprivilage: "ETMF Menu Approvals" },
    },
     {
      path: "/TmfDocQcList",
      name: "TmfDocQcList",
      component:TmfDocQcList,
      props: true,
      meta: { requiredAuth: true, roleprivilage: "ETMF Menu Approvals" },
    },
    {
      path: "/ClinicalSafetyDashboard",
      name: "ClinicalSafetyDashboard",
      component:ClinicalSafetyDashboard,
      meta: { requiredAuth: true, roleprivilage: "RBQM AE/SAE" },
    },
    {
      path: "/scheduleTask",
      name: "scheduleTask",
      component:scheduleTask,
      meta: { requiredAuth: true },
    },
    {
      path: "/exportOutput",
      name: "exportOutput",
      component:exportOutput,
      meta: { requiredAuth: true },
    },
    {
      path: "/RiskBasedMonitoring",
      name: "RiskBasedMonitoring",
      component:RiskBasedMonitoring,
      meta: { requiredAuth: true, roleprivilage: "RBQM Query" },
    },
    {
      path: "/analysisTreeQC",
      name: "analysisTreeQC",
      component:analysisTreeQC,
      meta: { requiredAuth: true },
    },
    {
      path: "/fhirViewer",
      name: "fhirViewer",
      component:fhirViewer,
      meta: { requiredAuth: true, roleprivilage: "Main Hub FHIR Data View" },
    },
    {
      path: "/FHIRpage/:subjectCode/:siteCode/:visitName/:subjectId/:siteId",
      name: "FHIRpage",
      component:FHIRpage,
      props: true,
      meta: { requiredAuth: true },
    },
    {
      path: "/inventoryTracking",
      name: "inventoryTracking",
      component:inventoryTracking,
      meta: { requiredAuth: true },
    },
    {
      path: "/crm",
      name: "crm",
      component:crm,
      meta: { requiredAuth: true },
    },
    {
      path: "/sapConnection",
      name: "sapConnection",
      component:sapConnection,
      meta: { requiredAuth: true },
    },
    {
      path: "/filediffpage",
      name: "filediffpage",
      component:filediffpage,
      meta: { requiredAuth: true },
    },
    {
      path: "/soa",
      name: "soa",
      component:soa,
      meta: { requiredAuth: true, roleprivilage: "Study Menu SoA" },
    },
    {
      path: "/graphvisual",
      name: "graphvisual",
      component:graphvisual,
      meta: { requiredAuth: true, roleprivilage: "Mainmenu Graph" },
    },
    {
      path: "/viewgraph",
      name: "viewgraph",
      component:viewgraph,
      meta: { requiredAuth: true },
    },
    {
      path: "/sdtm",
      name: "sdtm",
      component:sdtm,
      props: true,
      meta: { requiredAuth: true, roleprivilage: "Mainmenu SDTM Conversion" },
    },
    {
      path: "/uploadstudyprotocol",
      name: "uploadstudyprotocol",
      component:uploadstudyprotocol,
      props: true,
      meta: { requiredAuth: true, roleprivilage: "Mainmenu Protocol Data Import" },
    },
    {
      path: "/StudyProtocolMng",
      name: "StudyProtocolMng",
      component:StudyProtocolMng,
      props: true,
      meta: { requiredAuth: true },
    },
    {
      path: "/StudyManagment",
      name: "StudyManagment",
      component:StudyManagment,
      props: true,
      meta: { requiredAuth: true },
    },
    {
      path: "/FormManagement",
      name: "FormManagement",
      component:FormManagement,
      props: true,
      meta: { requiredAuth: true },
    },
    {
      path: "/VisitManagement",
      name: "VisitManagement",
      component:VisitManagement,
      props: true,
      meta: { requiredAuth: true },
    },
    {
      path: "/SiteManagement",
      name: "SiteManagement",
      component:SiteManagement,
      props: true,
      meta: { requiredAuth: true },
    },
    {
      path: "/SubjectManagement",
      name: "SubjectManagement",
      component:SubjectManagement,
      props: true,
      meta: { requiredAuth: true },
    },
    {
      path: "/ScheduleManagement",
      name: "ScheduleManagement",
      component:ScheduleManagement,
      props: true,
      meta: { requiredAuth: true },
    },
    {
      path: "/aecostmonitoring",
      name: "aecostmonitoring",
      component: aecostmonitoring,
      meta: { requiredAuth: true },
    },
    {
      path: "/costmonitoring",
      name: "costmonitoring",
      component: costmonitoring,
      meta: { requiredAuth: true },
    },
    {
      path: "/landingPage",
      name: "landingPage",
      component: landingPage,
      meta: { requiredAuth: true },
    },
    {
      path: "/sitequerymonitoring",
      name: "sitequerymonitoring",
      component: sitequerymonitoring,
      meta: { requiredAuth: true },
    },
    {
      path: "/siteperformance",
      name: "siteperformance",
      component: siteperformance,
      meta: { requiredAuth: true },
    },
    {
      path: "/siteactivitymonitoring",
      name: "siteactivitymonitoring",
      component: siteactivitymonitoring,
      meta: { requiredAuth: true },
    },
    {
      path: "/comparativelabresult",
      name: "comparativelabresult",
      component: comparativelabresult,
      meta: { requiredAuth: true },
    },
    {
      path: "/aesaemonitoring",
      name: "ae_sae_monitoring",
      component: ae_sae_monitoring,
      meta: { requiredAuth: true },
    },
    {
      path: "/priorconcomitantsummary",
      name: "priorconcomitantsummary",
      component: priorconcomitantsummary,
      meta: { requiredAuth: true },
    },
    {
      path: "/aeincidencetable",
      name: "aeincidencetable",
      component: aeincidencetable,
      meta: { requiredAuth: true },
    },
    {
      path: "/vitalsignsresultovertime",
      name: "vitalsignsresultovertime",
      component: vitalsignsresultovertime,
      meta: { requiredAuth: true },
    },
    {
      path: "/treatmentEmergentAE",
      name: "treatmentEmergentAE",
      component: treatmentEmergentAE,
      meta: { requiredAuth: true },
    },
    {
      path: "/advereventcrosstabulation",
      name: "advereventcrosstabulation",
      component: advereventcrosstabulation,
      meta: { requiredAuth: true },
    },
    {
      path: "/analyticalDashboard",
      name: "analyticalDashboard",
      component: AnalyticalDashboard,
      meta: { requiredAuth: true },
    },
    {
      path: "/studymonitoring",
      name: "StudyMonitoring",
      component: StudyMonitoring,
      meta: { requiredAuth: true },
    },
    {
      path: "/exposurereport",
      name: "exposurereport",
      component: exposurereport,
      meta: { requiredAuth: true },
    },
    {
      path: "/exposureandadverseevents",
      name: "exposureandadverseevents",
      component: exposureandadverseevents,
      meta: { requiredAuth: true },
    },
    {
      path: "/subjectstatusreport",
      name: "subjectstatusreport",
      component: subjectstatusreport,
      meta: { requiredAuth: true },
    },
    {
      path: "/DescriptiveStatisticReport",
      name: "descriptiveStatistic",
      component: descriptiveStatistic,
      meta: { requiredAuth: true, roleprivilage: "Study Data Analysis Descriptive Statistic Report" },
    },
    {
      path: "/aiList",
      name: "ailist",
      component: ailist
    },
    {
      path: "/formTemplates",
      name: "formTemplate",
      component: formTemplate,
      meta: { requiredAuth: true, roleprivilage: "Study Components Menu Visit Templates" },
    },
    {
      path: "/dynamicdashboard",
      name: "dynamicdashboard",
      component: dynamicdashboard,
       meta: { requiredAuth: true, roleprivilage: "Dashboard Dynamic Dashboard" },
    },

    {
      path: "/mlCriteriaCapture",
      name: "mlCriteriaCapture",
      component: mlCriteriaCapture
    },
    {
      path: "/test",
      name: "test",
      component: test
    },
    {
      path: "/ConfirmationScreen",
      name: "ConfirmationScreen",
      component: ConfirmationScreen
    },
    {
      path: "/templateview/:templateName/:tempId",
      name: "templateview",
      component: templateview,
      props: true,
      meta: { requiredAuth: true },
    },
    {
      path: "/eConsentList",
      name: "eConsent",
      component: eConsent,
      props: true,
      meta: { requiredAuth: true, roleprivilage: "Study Components Menu E-Consent" },
    },
    {
      path: "/survivalreport",
      name: "survivalreport",
      component: survivalreport,
      meta: { requiredAuth: true, roleprivilage: "Study Data Analysis Survival Analysis" },
    },
    {
      path: "/deathsummaryreport",
      name: "deathsummaryreport",
      component: deathsummaryreport,
      meta: { requiredAuth: true },
    },
    {
      path: "/vitalsignreport",
      name: "vitalsignreport",
      component: vitalsignreport,
      meta: { requiredAuth: true },
    },
    {
      path: "/vitalsigndescriptivestats",
      name: "vitalsigndescriptivestats",
      component: vitalsigndescriptivestats,
      meta: { requiredAuth: true },
    },
    {
      path: "/labresultreview",
      name: "labresultreview",
      component: labresultreview,
      meta: { requiredAuth: true },
    },
    {
      path: "/labdescriptivestatus",
      name: "labdescriptivestatus",
      component: labdescriptivestatus,
      meta: { requiredAuth: true },
    },
    {
      path: "/medicalhistory",
      name: "medicalhistory",
      component: medicalhistory,
      meta: { requiredAuth: true },
    },
    {
      path: "/medicalhistorycrosstab",
      name: "medicalhistorycrosstab",
      component: medicalhistorycrosstab,
      meta: { requiredAuth: true },
    },
    {
      path: "/labsummaryreport",
      name: "labsummeryreport",
      component: labsummeryreport,
      meta: { requiredAuth: true },
    },
    {
      path: "/aereport",
      name: "aereport",
      component: aereport,
      meta: { requiredAuth: true },
    },
    {
      path: "/formdesignertool",
      name: "formdesignertool",
      component: formdesignertool,
      meta: { requiredAuth: true },
    },
    {
      path: "/formdesigner",
      name: "formdesigner",
      component: formdesigner,
      props: true,
      meta: { requiredAuth: true, roleprivilage: "Form Designer Menu Designer Tool" },
    },
    {
      path: "/googlefitscreen",
      name: "googlefitscreen",
      component: googlefitscreen,
      meta: { requiredAuth: true, roleprivilage: "IOT Google Fit" },
    },
    {
      path: "/archive",
      name: "archive",
      component: archive,
      meta: { requiredAuth: true, roleprivilage: "Study Components Menu Archived Forms" },
    },
    {
      path: "/noprivilege",
      name: "noprivilege",
      component: noprivilege,
      meta: { requiredAuth: true },
    },
    {
      path: "/report",
      name: "report",
      component: report,
      meta: { requiredAuth: true, roleprivilage: "Reports Menu Schedule" },
    },
    {
      path: "/siteReport",
      name: "siteReport",
      component: siteReport,
      meta: { requiredAuth: true, roleprivilage: "Reports Menu Site Report" },
    },
    {
      path: "/visitSummaryReport",
      name: "visitSummaryReport",
      component: visitSummaryReport,
      meta: { requiredAuth: true, roleprivilage: "Reports Menu Visit Summary" },
    },
    {
      path: "/documentapprovallist",
      name: "documentapprovallist",
      component: documentapprovallist,
      meta: { requiredAuth: true, roleprivilage: "DMS Menu Document Approval" },
    },
    {
      path: "/patientreport",
      name: "patientreport",
      component: patientreport,
      meta: { requiredAuth: true, roleprivilage: "Reports Menu Patient Summary" },
    },
    {
      path: "/home",
      name: "Home",
      component: Home,
      meta: { requiredAuth: true, roleprivilage: "Dashboard Main Dashboard" },
    },
    {
      path: "/form/:isPatientVisit/:template/:study/:visitid",
      name: "Form",
      component: Form,
      props: true,
      meta: { requiredAuth: true },
    },
    {
      path: "/documentview/:referenceId/:versionId",
      name: "documentview",
      component: documentview,
      props: true,
      meta: { requiredAuth: true },
    },
    {
      path: "/viewdocument/:documentId/:versionNumber",
      name: "viewdocument",
      component: viewdocument,
      props: true,
      meta: { requiredAuth: true },
    },
    {
      path: "/",
      name: "login",
      component: login,
      meta: { requiredAuth: false },
    },
    {
      path: "/PatientLoginScreen",
      name: "PatientLoginScreen",
      component: PatientLoginScreen,
      meta: { requiredAuth: true },
    },
    {
      path: "/StudyBasedUserList",
      name: "StudyBasedUserList",
      component: StudyBasedUserList,
      meta: { requiredAuth: true, roleprivilage: "Study Components Menu Users" },
    },
    {
      path: "/PatientDashboard",
      name: "PatientDashboard",
      component: PatientDashboard,
      meta: { requiredAuth: true },
    },
    {
      path: "/reportdashboard",
      name: "reportdashboard",
      component: reportdashboard,
      meta: { requiredAuth: true, roleprivilage: "Reports Menu Report Dashboard" },
    },
    {
      path: "/dmssummaryreport",
      name: "dmssummaryreport",
      component: dmssummaryreport,
      meta: { requiredAuth: true, roleprivilage: "DMS Menu Document Summary", add: "Document Patient Approve" },
    },
    {
      path: "/signup",
      name: "Signup",
      component: Signup,
      meta: { requiredAuth: true },
    },
    {
      path: "/createuser/:userid",
      name: "createuser",
      component: createuser,
      meta: {
        requiredAuth: true,
        add: "Users Create User",
        edit: "Users Edit",
      },
      props: true,
    },
    {
      path: "/submitForm",
      name: "submitForm",
      component: submitForm,
      meta: { requiredAuth: true, roleprivilage: "Mainmenu Fill Form," },
      props: true,
    },
    {
      path: "/subject_schedule",
      name: "subject_schedule",
      component: subject_schedule,
      meta: { requiredAuth: true, roleprivilage: "Mainmenu Fill Form," },
      props: true,
    },
    {
      path: "/study/:studyid",
      name: "study",
      component: study,
      meta: {
        requiredAuth: true,
        add: "Studylist Create Study",
        edit: "Studylist Edit",
      },
      props: true,
    },
    {
      path: "/editLabs/:id",
      name: "editLabs",
      component: editLabs,
      meta: {
        requiredAuth: true,
      },
      props: true,
    },
      {
      path: "/assignTest/:id",
      name: "assignTest",
      component: assignTest,
      meta: {
        requiredAuth: true,
      },
      props: true,
    },
      {
      path: "/editLabtest/:id",
      name: "editLabtest",
      component: editLabtest,
      meta: {
        requiredAuth: true,
      },
      props: true,
    },
    {
      path: "/sitesummary",
      name: "sitesummary",
      component: sitesummary,
      meta: { requiredAuth: true, roleprivilage: "Dashboard Site Summary" },
    },
    {
      path: "/studysummary",
      name: "studysummary",
      component: studysummary,
      meta: { requiredAuth: true, roleprivilage: "Dashboard Study Summary" },
    },
    {
      path: "/nursesummary",
      name: "nursesummary ",
      component: nursesummary,
      meta: { requiredAuth: true, roleprivilage: "Dashboard Nurse Dashboard" },
    },
    {
      path: "/visitsummary",
      name: "visitsummary",
      component: visitsummary,
      meta: { requiredAuth: true, roleprivilage: "Dashboard Visit Summary" },
    },
    {
      path: "/nursediary",
      name: "nursediary",
      component: nursediary,
      meta: { requiredAuth: true, roleprivilage: "Dashboard Nurse Diary" },
    },
    {
      path: "/listform",
      name: "listform",
      component: listform,
      meta: { requiredAuth: true, roleprivilage: "Study Components Menu Submitted Forms" },
      // issue resolve
    },
    {
      path: "/meddralistforms",
      name: "meddralistforms",
      component: meddralistforms,
      meta: { requiredAuth: true, roleprivilage: "Study Components Menu Submitted Forms" },
      // issue resolve
    },
    {
      path: "/meddraViewer/:formId/:tempId/:formStatus",
      name: "meddraViewer",
      component: meddraViewer,
      props: true,
      meta: { requiredAuth: true},
    },
    {
      path: "/reviewFormList",
      name: "reviewFormList",
      component: reviewFormList,
      meta: { requiredAuth: true, roleprivilage: "Study Components Menu Partially Filled Forms" },
      // issue resolve
    },
    {
      path: "/formssummery",
      name: "formssummery",
      component: formssummery,
      meta: { requiredAuth: true, roleprivilage: "Study Form Summary" },
      // issue resolve
    },
    {
      path: "/formSummary",
      name: "formSummary",
      component: formSummary,
      meta: { requiredAuth: true, roleprivilage: "Study Components Menu Form Summary" },
      // issue resolve
    },
{
      path: "/showformwithdata/:formsesid",
      name: "showformwithdata",
      component: showformwithdata,
      props: true,
      meta: { requiredAuth: true },
    },
    {
      path: "/showform/:closeoption/:formsesid/:fromArchive",
      name: "showform",
      component: showform,
      props: true,
      meta: { requiredAuth: true },
    },
    {
      path: "/viewform/:formsesid",
      name: "viewform",
      component: viewform,
      props: true,
      meta: { requiredAuth: true },
    },
    {
      path: "/viewformtemplate/:formsesid",
      name: "viewformtemplate",
      component: viewformtemplate,
      props: true,
      meta: { requiredAuth: true },
    },

    {
      path: "/editForm/:closeoption/:formsesid/:isPatientVisit",
      name: "editForm",
      component: editForm,
      props: true,
      meta: { requiredAuth: true },
    },
    {
      path: "/mapform/:formsesid",
      name: "mapform",
      component: mapform,
      props: true,
      meta: { requiredAuth: true },
    },
    {
      path: "/displayform",
      name: "displayform",
      component: displayform,
      meta: { requiredAuth: true, roleprivilage: "Study Components Menu Unassigned Form" },
    },
    {
      path: "/userlisting",
      name: "userlisting",
      component: userlist,
      meta: { requiredAuth: true, roleprivilage: "Administration Users", add: "Userlisting Audit Trails" },
    },
    {
      path: "/devicecontrollers",
      name: "devicecontrollers",
      component: devicecontrollers,
      meta: { requiredAuth: true,roleprivilage: "Administration Device Controllers"  },
    },
    {
      path: "/studylist",
      name: "studylist",
      component: studylist,
      meta: { requiredAuth: true, roleprivilage: "Mainmenu Study List" },
    },

    {
      path: "/visitlist/:stdid",
      name: "visitlist",
      component: visitlist,
      props: true,
      meta: { requiredAuth: true, roleprivilage: "Studylist Visit", add: "Study Audit Trails" },
    },
    {
      path: "/addvisit/:visitId",
      name: "addvisit",
      component: addvisit,
      meta: { requiredAuth: true },
      props: true,
    },
    {
      path: "/sitelist",
      name: "sitelist",
      component: sitelist,
      meta: { requiredAuth: true, roleprivilage: "Study Components Menu Sites", add: "Sites Audit Trails" },
    },
    {
      path: "/managesite/:userid",
      name: "managesite",
      component: managesite,
      props: true,
      meta: {
        requiredAuth: true,
        add: "Sites Create Site",
        edit: "Sites Edit",
      },
    },
    {
      path: "/managecountry/:countryId",
      name: "managecountry",
      component: managecountry,
      props: true,
      meta: {
        requiredAuth: true,
        add: "Sites Create Site",
        edit: "Sites Edit",
      },
    },
    {
      path: "/patientlisting",
      name: "patientList",
      component: patientlist,
      meta: { requiredAuth: true, roleprivilage: "Subjects Audit Trails" },
    },
    {
      path: "/patientLoginPassword/:patientLoginId",
      name: "patientLoginPassword",
      component: patientLoginPassword,
      meta: { requiredAuth: false },
      props: true,
    },
    {
      path: "/patientLoginList",
      name: "patientLoginList",
      component: patientLoginList,
      meta: { requiredAuth: true, roleprivilage: "Study Administration Menu Patient Login" },
    },
    {
      path: "/managepatient/:patientId",
      name: "managePatient",
      component: managePatient,
      props: true,
      meta: {
        requiredAuth: true,
        add: "Subjects Create Subject",
        edit: "Subjects Edit",
      },
    },
    {
      path: "/patientlist",
      name: "patientList",
      component: patientlist,
      meta: { requiredAuth: true, roleprivilage: "Study Components Menu Subjects" },
    },
    {
      path: "/templatelist",
      name: "templatelist",
      component: templatelist,
      meta: { requiredAuth: true, roleprivilage: "Form Library Menu Templates" },
      props: true,
    },
    {
      path: "/templatelisting",
      name: "templatelisting",
      component: templatelisting,
      meta: { requiredAuth: true, roleprivilage: "Form Library Menu Templates" },
      props: true,
    },
    {
      path: "/digitalform/:details",
      name: "digitalform",
      component: digitalform,
      meta: { requiredAuth: true, roleprivilage: "Form Library Menu Approve Template" },
      props: true,
    },
    {
      path: "/digitalformview/:closedoption/:tempId/:formId/:comments",
      name: "digitalformview",
      component: digitalformview,
      meta: { requiredAuth: true },
      props: true,
    },
    {
      path: "/visitforms",
      name: "visitforms",
      component: visitforms,
      meta: { requiredAuth: true, roleprivilage: "Mainmenu Data Entry" },
    },
    {
      path: "/viewTemplate/:closedoption/:tempId",
      name: "viewTemplate",
      component: viewTemplate,
      meta: { requiredAuth: true },
      props: true,
    },
    {
      path: "/viewFormTemplate/:closedoption/:tempId",
      name: "viewFormTemplate",
      component: viewFormTemplate,
      meta: { requiredAuth: true },
      props: true,
    },
    {
      path: "/query/:closedoption/:queryid",
      name: "querymapping",
      component: querymapping,
      meta: { requiredAuth: true },
      props: true,
    },
    {
      path: "/visittemplate",
      name: "visittemplate",
      component: visittemplate,
      meta: { requiredAuth: true, roleprivilage: "Study Administration Menu Change Schedule Template" },
      props: false,
    },
    {
      path: "/userpassword/:userid",
      name: "userpassword",
      component: userpassword,
      meta: { requiredAuth: false },
      props: true,
    },
    {
      path: "/ResetPassword/:token/:resetType/:source",
      name: "ResetPassword",
      component: ResetPassword,
      meta: { requiredAuth: false },
      props: true,

    },
    {
      path: "/CheckEmail",
      name: "CheckEmail",
      component: CheckEmail,
      meta: { requiredAuth: false },
    },
    {
      path: "/queryList",
      name: "queryList",
      component: queryList,
      meta: { requiredAuth: true, roleprivilage: "Query Menu Received" },
      props: false,
    },
    {
      path: "/general_querylist",
      name: "general_querylist",
      component: general_querylist,
      meta: { requiredAuth: true, roleprivilage: "Query Menu General" },
      props: false,
    },
     {
      path: "/labs",
      name: "labMaster",
      component: labMaster,
      meta: { requiredAuth: true, roleprivilage: "Labs Menu Lab Master" },
      props: false,
    },
    {
      path: "/sentQueryList",
      name: "sentQueryList",
      component: sentQueryList,
      meta: { requiredAuth: true, roleprivilage: "Query Menu Sent" },
      props: false,
    },
     {
      path: "/sentQueryListForAlert",
      name: "sentQueryListForAlert",
      component: sentQueryListForAlert,
      meta: { requiredAuth: true, roleprivilage: "Query Menu Sent" },
      props: false,
    },
    {
      path: "/allQueryList",
      name: "allQueryList",
      component: allQueryList,
      meta: { requiredAuth: true, roleprivilage: "Query Menu All Queries" },
      props: false,
    },
    {
      path: "/ReceivedQueryForAlerts",
      name: "ReceivedQueryForAlerts",
      component: ReceivedQueryForAlerts,
      meta: { requiredAuth: true, roleprivilage: "Query Menu All Queries" },
      props: false,
    },
    {
      path: "/allQueriesForAlert",
      name: "allQueriesForAlert",
      component: allQueriesForAlert,
      meta: { requiredAuth: true, roleprivilage: "Query Menu All Queries" },
      props: false,
    },
    {
      path: "/raiseQuery/:FormId/:routeQuery/:pageno",
      name: "raiseQuery",
      component: raiseQuery,
      meta: { requiredAuth: true, roleprivilage: "Forms Form Query" },
      props: true,
    },
    {
      path: "/generalQuery",
      name: "generalQuery",
      component: generalQuery,
      meta: { requiredAuth: true, roleprivilage: "Query Menu General" },
    },
    {
      path: "/visitlist",
      name: "visitList",
      component: visitList,
      meta: { requiredAuth: true, roleprivilage: "Study Components Menu Visits" },
      props: false,
    },
    {
      path: "/userprivilege/:userid",
      name: "userPrivilege",
      component: userPrivilege,
      props: true,
      meta: { requiredAuth: true, roleprivilage: "Users User Privilege" },
    },
    {
      path: "/settings",
      name: "settings",
      component: Settings,
      meta: { requiredAuth: true },
      props: false,
    },
    {
      path: "/profileSettings",
      name: "profileSettings",
      component: profileSettings,
      meta: { requiredAuth: true },
      props: false,
    },
    {
      path: "/manageRole/:roleId",
      name: "manageRole",
      component: manageRole,
      meta: {
        requiredAuth: true,
        add: "Roles Create Role",
        edit: "Roles Edit",
      },
      props: true,
    },
    {
      path: "/roleList",
      name: "roleList",
      component: roleList,
      meta: { requiredAuth: true, roleprivilage: "Administration Roles" },
      props: false,
    },
    {
      path: "/visitSheduleList/:patientId",
      name: "visitSheduleList",
      component: visitSheduleList,
      meta: { requiredAuth: true, roleprivilage: "Subjects Schedule" },
      props: true,
    },
    {
      path: "/roleScreen",
      name: "roleScreen",
      component: roleScreen,
      meta: {
        requiredAuth: true,
        roleprivilage: "Administration Role Privileges",
      },
      props: true,
    },
    {
      path: "/screen",
      name: "screen",
      component: screen,
      meta: { requiredAuth: true, roleprivilage: "Administration Screen" },
    },
    {
      path: "/siteprivilege",
      name: "siteprivilege",
      component: siteprivilege,
      meta: {
        requiredAuth: true,
        roleprivilage: "Administration Site Privilege",
      },
    },
    {
      path: "/fieldprivileges",
      name: "fieldprivileges",
      component: fieldprivileges,
      meta: {
        requiredAuth: true,
        roleprivilage: "Administration Field Privileges",
      },
    },
    {
      path: "/studytemplate",
      name: "studytemplate",
      component: studytemplate,
      meta: { requiredAuth: true, roleprivilage: "Mainmenu Study Template" },
    },
    {
      path: "/PatientScheduleView",
      name: "PatientScheduleView",
      component: PatientScheduleView,
      meta: { requiredAuth: true, roleprivilage: "Study Administration Menu Subject Schedule" },
    },
    {
      path: "/documentsummary",
      name: "documentsummary",
      component: documentsummary,
      meta: { requiredAuth: true, roleprivilage: "DMS Menu Documents", add: "Document Summary Approve" },
    },
    {
      path: "/googlefit",
      name: "googlefit",
      component: googlefit1,
      meta: { requiredAuth: true },
    },
     {
      path: "/labTest",
      name: "labTest",
      component: labTest,
      meta: { requiredAuth: true },
    },
    {
      path: "/IOTDevices",
      name: "device",
      component: device,
      meta: { requiredAuth: true },
    },
    {
      path: "/patientdocument/:patientId",
      name: "patientdocument",
      component: patientdocument,
      meta: { requiredAuth: true, roleprivilage: "Subjects Add Document" },
      props: true,
    },
    {
      path: "/IOTPatients",
      name: "IOTPatients",
      component: iotpatients,
      meta: { requiredAuth: true },
    },
    {
      path: "/folderstudy/:userid",
      name: "folderstudy",
      component: folderstudy,
      meta: { requiredAuth: true, add: "Folder Study Approve" },
      props: true,
    },
    {
      path: "/unscheduledvisits",
      name: "unscheduledvisits",
      component: unscheduledvisits,
      meta: { requiredAuth: true, roleprivilage: "Study Administration Menu Unscheduled Visits" },
      props: true,
    },
    {
      path: "/folder/:userid/:siteCode",
      name: "folder",
      component: folder,
      meta: { requiredAuth: true, add: "Folder Approve" },
      props: true,
    },

    {
      path: "/dms",
      name: "dms",
      component: dms,
      meta: { requiredAuth: true, roleprivilage: "DMS Menu Document Upload", add: "Dms Approve" },
    },
    {
      path: "/document_patient/:userid/:siteCode",
      name: "document_patient",
      component: document_patient,
      meta: { requiredAuth: true, add: "Document Patient Approve" },
      props: true,
    },
    {
      path: "/transferSubject",
      name: "transferSubject",
      component: transferSubject,
      meta: {},
      props: true,
    },
    {
      path: "/formtransfer",
      name: "formtransfer",
      component: formtransfer,
      meta: {},
      props: true,
    },
    {
      path: "/videocall/:userId",
      name: "videocall",
      component: VideoCall,
      props: true,
      meta: { requiredAuth: false},
    },
    {
      path: "/studyProfile",
      name: "studyProfile",
      component: studyProfile,
      meta: { requiredAuth: true },
      props: true,
    },
     {
      path: "/reviewStudyVersion",
      name: "createNewVersion",
      component: createNewVersion,
      meta: { requiredAuth: true },
      props: true,
    },
    {
      path: "/dataExport",
      name: "dataExport",
      component: dataExport,
      meta: { requiredAuth: true },
      props: true,
    },
    {
      path: "/dataStandard",
      name: "dataStandard",
      component: dataStandard,
      meta: { requiredAuth: true },
      props: true,
    },
    {
      path: "/interimDataset",
      name: "interimDataset",
      component: interimDataset,
      meta: { requiredAuth: true },
      props: true,
    },
    {
      path: "/FormSuggestions",
      name: "FormSuggestions",
      component: FormSuggestions,
      meta: { requiredAuth: true },
      props: true,
    },
    {
      path: "/PatientScreeningReport",
      name: "PatientScreeningReport",
      component: PatientScreeningReport,
      meta: { requiredAuth: true, roleprivilage: "Predictive Analytics Module Patient Screening" },
    },
    {
      path: "/PatientRetention",
      name: "PatientRetention",
      component: PatientRetention,
      meta: { requiredAuth: true, roleprivilage: "Predictive Analytics Module Patient Retention" },
    },
    {
      path: "/RetentionDashboard",
      name: "RetentionDashboard",
      component: RetentionDashboard,
      meta: { requiredAuth: true },
    },
    {
      path: "/demographicReport",
      name: "demographicReport",
      component: demographicReport,
      meta: { requiredAuth: true },
    },
    {
      path: "/labResultTrend",
      name: "labResultTrend",
      component: labResultTrend,
      meta: { requiedAuth: true }
    },
    {
      path: "/ae_OverlayLabsReport",
      name: "ae_OverlayLabsReport",
      component: ae_OverlayLabsReport,
      meta: {requiedAuth: true}
    },
    {
      path: "/patientenrolment/:patientLoginId",
      name: "patientenrolment",
      component: patientenrolment,
      meta: {requiedAuth: false},
      props: true,
    },
    {
      path: "/trainingMaterials/:patientLoginId",
      name: "trainingMaterials",
      component: trainingMaterials,
      meta: {requiedAuth: false},
      props: true,
    },
    {
      path: "/consentformlist/:patientLoginId",
      name: "consentFormList",
      component: consentFormList,
      meta: { requiredAuth: true },
      props: true,
    },
    {
      path: "/subjectlogin/:patientLoginId",
      name: "subjectlogin",
      component: subjectlogin,
      props: true,
      meta: { requiredAuth: false },
    },
    {
      path: "/acknowledgement",
      name: "acknowledgement",
      component: acknowledgement,
      meta: { requiredAuth: true },
      props: false,
    },
    {
      path: "/patientUpdate/:patientLoginId",
      name: "patientUpdate",
      component:patientUpdate,
      props: true,
    },
    {
      path: "/tocgenerate",
      name: "tocgenerate",
      component:tocgenerate,
      props: true,
      meta: { requiredAuth: true },
    },
    {
      path: "/stats/:id/:editoption",
      name: "stats",
      component: stats,
      props: true,
    },
    {
      path: "/Macro_Management",
      name: "Macro_Management",
      component: Macro_Management,
      props: true,
    },
    {
      path: "/analysis_report",
      name: "analysis_report",
      component: analysis_report,
      props: true,
      meta: { requiredAuth: true },
    },
    {
      path: "/statqc_report",
      name: "statqc_report",
      component: statqc_report,
      props: true,
      meta: { requiredAuth: true },
    },
    {
      path: "/statusentry_report",
      name: "statusentry_report",
      component: statusentry_report,
      props: true,
      meta: { requiredAuth: true },
    },
    {
      path: "/programvalidation_report",
      name: "programvalidation_report",
      component: programvalidation_report,
      props: true,
      meta: { requiredAuth: true },
    },
    {
      path: "/traceability_report",
      name: "traceability_report",
      component: traceability_report,
      props: true,
      meta: { requiredAuth: true },
    },
    {
      path: "/epro",
      name: "epro",
      component: ePRO,
      props: true,
      meta: { requiredAuth: true },
    },
    {
      path: "/alerts",
      name: "alerts",
      component: Alerts,
      props: true,
      meta: { requiredAuth: true },
    },
    {
      path: "/setalert",
      name: "setalert",
      component:Setalert,
      props: true,
      meta: { requiredAuth: true },
    },
    {
      path: "/SetAlertModal",
      name: "SetAlertModal",
      component:Setalert,
      props: true,
      meta: { requiredAuth: true },
    },
    {
      path: "/ViewAlertModal",
      name: "ViewAlertModal",
      component:Setalert,
      props: true,
      meta: { requiredAuth: true },
    },
    {
      path: "/RactFileImport",
      name: "RactFileImport",
      component:ractfileimport,
      props: true,
      meta: { requiredAuth: true},
    },
    {
      path: "/importtoformlibrary",
      name: "importtoformlibrary",
      component:importtoformlibrary,
      props: true,
      meta: { requiredAuth: true},
    },
    {
      path: "/ractTool",
      name: "ractTool",
      component: ractTool,
      props: false,
      meta: { requiredAuth: true},
    },
    {
      path: "/AlertSummary",
      name: "AlertSummary",
      component:AlertSummary,
    },
    {
      path: "/riskSummary",
      name: "riskSummary",
      component:riskSummary,
      props: true,
    },
    {
      path: "/criticalDataInventory",
      name: "criticalDataInventory",
      component:criticalDataInventory,
      props: true,
    }, 
    {
      path: "/sdvSummary",
      name: "sdvSummary",
      component:sdvSummary,
      props: true,
    },
    {
      path: "/visitInfo",
      name: "visitInfo",
      component: visitInfo,
      props: true,
    },
    {
      path: "/researchFhirSubject",
      name: "ResearchFhirSubject",
      component: ResearchFhirSubject,
      meta: { requiredAuth: true},
    },
    {
      path: "/dataSignalOverview",
      name: "DataSignalOverview",
      component: DataSignalOverview,
      meta: { requiredAuth: true},
    }

    
  ];

  const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes: routes,
  });
  router.afterEach(async function (to, from) {
    store.dispatch('setPrevRoute', from && from.name ? from.name : null)
    const auth = await store.getters.authenticated;
    const privilegevalues = await store.getters.getRolesprivilegeData;
  
    if (auth && from.fullPath === "/" && privilegevalues == "test test,") {
      router.push(`/noprivilege`);
    }
  });
  router.beforeEach(async (to, from, next) => {
    // alert(localStorage.getItem('lang'));
    const auth = await store.getters.authenticated;
    const isactive = await store.getters.isTokenActive;
    const privilegevalues = await store.getters.getRolesprivilegeData;
      const userRoles = store.getters.getRolesData || [];
    if (!isactive) {
      localStorage.clear();
      location.reload();
    }
    // console.log("is authenticated ", store.getters.authenticated);
    // console.log(store.getters.getAuthData.token);
    const paramsLocale = localStorage.getItem('lang') ? localStorage.getItem('lang') : "en";
    // const paramsLocale = "en";
    if (!i18n.global["availableLocales"].includes(paramsLocale)) {
      await loadLocaleMessages(i18n, paramsLocale);
    }
    setI18nLanguage(i18n, paramsLocale);
    if (to.name != "querymapping" && to.name != "general_querylist") {
      if (store.getters.getQueryType != '') {
        store.dispatch("setQueryType", '')
      }
    }
    window.scrollTo(0, 0);
    if (auth && userRoles.includes('450eaffd-b42d-463b-8c4e-9b9b68cf2db8')) {
      if (to.fullPath !== "/f4pViewer") {
        return next({ path: "/f4pViewer" });
      }
    }
    if ((auth && to.fullPath === "/" && privilegevalues == "test test,") || (auth && !userRoles.includes('450eaffd-b42d-463b-8c4e-9b9b68cf2db8') && to.fullPath === "/f4pViewer")) {
      return next({ path: "/noprivilege" });
    } else if (auth && to.fullPath === "/" && privilegevalues != "test test,") {
      console.log(auth);
      return next({ path: "/home" });
    } else if (!auth && to.meta.requiredAuth) {
      return next({ path: "/" });
    } else if (
      auth &&
      to.meta.roleprivilage &&
      !privilegevalues.includes(to.meta.roleprivilage)
    ) {
      return next({ path: "/noprivilege" });
    } else if (
      auth &&
      to.meta.add &&
      to.meta.edit &&
      !privilegevalues.includes(to.meta.add) &&
      !privilegevalues.includes(to.meta.edit)
    ) {
      return next({ path: "/noprivilege" });
    }
    return next();
  });
  return router;
}

